/**
 * Why an `InvoiceRunItem` was SKIPPED.
 *
 * - `RACED` — the worker's per-item re-validation found that one or more of
 *   the planned units had been consumed by a concurrent invoice (per-patient
 *   or per-plan) in the interim between command time and worker pickup.
 * - `NO_LONGER_ELIGIBLE` — the planned units were no longer in the office-
 *   location reader's `eligible[]` re-read (e.g. unit was deleted, the plan
 *   was cancelled, the price list became unresolvable since the snapshot).
 * - `CANCELED` — left PENDING when a user-initiated cancel was observed.
 * - `ORPHANED` — left PENDING when the daily sweeper promoted an
 *   IN_PROGRESS run older than the orphan threshold to FAILED.
 *
 * Persisted as the string literal value — these strings are part of the
 * domain contract and surface verbatim in the per-row UI tooltip.
 */
export var InvoiceRunSkipReason;
(function (InvoiceRunSkipReason) {
    InvoiceRunSkipReason["RACED"] = "raced";
    InvoiceRunSkipReason["NO_LONGER_ELIGIBLE"] = "no_longer_eligible";
    InvoiceRunSkipReason["CANCELED"] = "canceled";
    InvoiceRunSkipReason["ORPHANED"] = "orphaned";
})(InvoiceRunSkipReason || (InvoiceRunSkipReason = {}));
//# sourceMappingURL=invoice-run-skip-reason.enum.js.map